import PendingUpdatesModel, { PendingUpdateType } from "../Models/Pending/Pending.Model";

export default function useHasPendingUpdates(updateTypes?: { type: PendingUpdateType; id: number | string }[]): boolean {
  const pendingUpdates = PendingUpdatesModel.useState((state) => state.pendingUpdates);

  if (!updateTypes || updateTypes.length === 0) {
    return false;
  }
  return updateTypes.some((update) => pendingUpdates[PendingUpdatesModel.keyForUpdate(update.type, update.id)]);
}
